<template>
	<div class="row bold-400" v-if="status">
		<div class="col-md-12">
			<h3 class="box-title pull-left">{{ status.name }}</h3>
			<template v-if="statuses">
				<template v-if="statuses.length">
					<div class="btn-toolbar m-b-20" role="toolbar">
						<div class="btn-group pull-right">
							<button @click="reload" class="btn btn-default">
								<i class="fa fa-refresh" aria-hidden="true"></i>
							</button>
						</div>
						<div class="visible-xs btn-group pull-right">
							<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<span class="caret"></span>
							</button>
							<ul class="dropdown-menu">
								<li
									v-for="status in statuses"
									@click="loadStatus(status)"
									:class="{ 'active' : status.id == datatable.moreParams.filter.budget_status_id }">
									<a href="#" class="active">
										<template v-if="status.lang">
											{{ status.lang.name }}
										</template>
										<template v-else>
											{{ status.name }}
										</template>
									</a>
								</li>
							</ul>
						</div>
						<div class="hidden-xs btn-group pull-right">
							<template v-for="status in statuses">
								<template v-if="datatable.moreParams.filter.budget_status_id == status.id">
									<button
										disabled
										:class="'active btn btn-' + status.class"
										:title="status.name">
										<span v-html="status.icon"></span>
									</button>
								</template>
								<template v-else>
									<button
										@click="loadStatus(status)"
										:class="'btn btn-' + status.class"
										:title="status.name">
										<span v-html="status.icon"></span>
									</button>
								</template>
							</template>
						</div>
					</div>
				</template>
			</template>
		</div>
		<div class="col-md-12" v-if="datatable.moreParams.filter.budget_status_id">
			<loading :active="datatable.loading" class="velmld-overlay-light">
				<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
			</loading>

			<div class="table-responsive">
				<datatable
					ref="datatable"
					:append-params="datatable.moreParams"
					:css="datatable.css.table"
					:api-url="datatable.api"
					:fields="datatable.fields"
					:per-page="datatable.page"
					:pagination-path="datatable.path"
					:sort-order="datatable.sortOrder"
					@vuetable:pagination-data="onPaginationData"
					@vuetable:loading="loading"
					@vuetable:loaded="loaded">

					<template slot="id" slot-scope="props">
						<template v-if="props.rowData.lock"><router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/budgets/' + props.rowData.id">{{ props.rowData.id }}</router-link></template>
						<template v-else><router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/budgets/' + props.rowData.id + '/edit'">{{ props.rowData.id }}</router-link></template>
					</template>

					<template slot="read" slot-scope="props">
						<template v-if="props.rowData.mark_as_read">
							<i class="fa fa-envelope-open" :title="props.rowData.mark_as_read_date | moment" aria-hidden="true"></i>
						</template>
					</template>

					<template slot="title" slot-scope="props">
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/budgets/' + props.rowData.id">
							{{ props.rowData.title }}
						</router-link>
						<template v-if="props.rowData.invoice || props.rowData.order">
							<template v-if="props.rowData.title">
								<br>
							</template>
							<router-link
								v-if="props.rowData.order"
								:title="'Pedido ' + $platform.setting.number_symbol + props.rowData.order.id"
								class="btn btn-default btn-xs btn-rounded"
								:to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/orders/' + props.rowData.order.id">
								Pedido #{{ props.rowData.order.id }}
							</router-link>
							<router-link
								v-if="props.rowData.invoice"
								:title="'Factura '+ $platform.setting.number_symbol + props.rowData.invoice.number"
								class="btn btn-default btn-xs btn-rounded"
								:to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/invoices/' + props.rowData.invoice.id">
								Factura {{ $platform.setting.number_symbol }}{{ props.rowData.invoice.prefix }}{{ props.rowData.invoice.number }}
							</router-link>
						</template>
					</template>

					<template slot="customer" slot-scope="props">
						<router-link
							v-if="props.rowData.customer"
							:to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/customers/' + props.rowData.customer.id">
							{{ props.rowData.customer.name }}
						</router-link>
						<br>
						<router-link
							class="btn btn-default btn-xs btn-rounded"
							v-if="props.rowData.customer"
							:to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/customers/' + props.rowData.customer.id">
							<template v-if="$platform.setting.customers.custom_reference">
								{{ props.rowData.customer.reference }}
							</template>
							<template v-else>
								{{ $platform.setting.number_symbol }}{{ props.rowData.customer.id }}
							</template>
						</router-link>
					</template>

					<template slot="status" slot-scope="props">
						<template v-if="props.rowData.status">
							<template v-if="!props.rowData.customer_id">
								<label :class="'label label-' + props.rowData.status.class" v-html="props.rowData.status.icon" :title="props.rowData.status.name"></label>
							</template>
							<template v-else>
								<label @click="$refs.ChangeStatus.open(props.rowData)" :class="'link label label-' + props.rowData.status.class" v-html="props.rowData.status.icon" :title="props.rowData.status.name"></label>
							</template>
						</template>
						<template v-if="props.rowData.status.id == 2">
							<template v-if="props.rowData.sent_at">
								<br>
								<small>
									{{ props.rowData.sent_at | moment(false) }}
								</small>
							</template>
						</template>
					</template>

					<template slot="base_amount" slot-scope="props">
						{{ props.rowData.base_amount | currency({symbol: ''}) }}
					</template>

					<template slot="save" slot-scope="props">
						{{ props.rowData.save | currency({symbol: ''}) }}
					</template>

					<template slot="amount" slot-scope="props">
						{{ props.rowData.amount | currency({symbol: ''}) }}
					</template>

					<template slot="taxes" slot-scope="props">
						{{ props.rowData.taxes | currency({symbol: ''}) }}
					</template>

					<template slot="total" slot-scope="props">
						{{ props.rowData.total | currency({symbol: ''}) }}
					</template>

					<template slot="assigned" slot-scope="props">
						<router-link
						v-if="props.rowData.assigned"
						:to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/users/' + props.rowData.assigned_to">
							<span v-if="props.rowData.assigned.profile">
								<img
									v-if="props.rowData.assigned.profile.avatar"
									:title="props.rowData.assigned.email"
									:src="props.rowData.assigned.profile.avatar"
									class="img-circle" width="30">
								<i v-else :title="props.rowData.assigned.email" aria-hidden="true" class="fa fa-user-circle-o"></i>
							</span>
						</router-link>
					</template>

					<template slot="author" slot-scope="props">
						<router-link
							v-if="props.rowData.author"
							:to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/users/' + props.rowData.author_id">
							<span v-if="props.rowData.author.profile">
								<img
									v-if="props.rowData.author.profile.avatar"
									:title="props.rowData.author.email"
									:src="props.rowData.author.profile.avatar"
									class="img-circle" width="30">
								<i v-else :title="props.rowData.author.email" aria-hidden="true" class="fa fa-user-circle-o"></i>
							</span>
						</router-link>
					</template>

					<template slot="sent_at" slot-scope="props">
						<template v-if="props.rowData.sent_at">
							{{ props.rowData.sent_at | moment }}
						</template>
					</template>

					<template slot="actions" slot-scope="props">
						<div class="btn-group pull-right">
							<button @click="$refs.actions.open(props.rowData)" type="button" class="btn btn-default visible-sm visible-xs">
								<span class="caret"></span>
							</button>
							<div class="dropdown hidden-sm hidden-xs">
								<button :id="'btn-dropdown-invoice-' + props.rowData.id" type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">
									<span class="caret"></span>
								</button>
								<ul class="dropdown-menu dropdown-menu-right">
									<li>
										<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/budgets/' + props.rowData.id">
											<i class="fa fa-eye fa-fw" aria-hidden="true"></i>
											Ver
										</router-link>
									</li>
									<li>
										<router-link :disabled="props.rowData.lock == 1" :class="{ 'disabled': props.rowData.lock }" :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/budgets/'+props.rowData.id+'/edit'">
											<i class="ti-pencil-alt fa-fw"></i>
											Editar
										</router-link>
									</li>
									<li @click="duplicate(props.rowData)">
										<a href="javascript:void(0)">
											<i class="fa fa-clone fa-fw" aria-hidden="true"></i>
											Duplicar
										</a>
									</li>
									<li>
										<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/management/budgets/' + props.rowData.random" target= '_blank'>
											<i class="fa fa-file-pdf-o fa-fw" aria-hidden="true"></i>
											Ver PDF
										</router-link>
									</li>
									<li @click="destroy(props.rowData)" :class="{ 'disabled' : props.rowData.budget_status_id != 1 && props.rowData.budget_status_id != 6 }">
										<a href="javascript:void(0)">
											<i class="icon-trash fa-fw"></i>
											Eliminar
										</a>
									</li>
								</ul>
							</div>
						</div>
					</template>
				</datatable>
			</div>

			<pagination-info ref="paginationInfo"
			:info-template="$t('interface.datatable.info_template')"
			:noDataTemplate="$t('interface.datatable.no_data_template')">
			</pagination-info>

			<div class="form-inline">
				<div class="form-group">
					<label class="control-label">{{ $t("interface.datatable.records_per_page") }}: </label>
					<div class="input-group">
						<select @change="reload" class="form-control" v-model="datatable.page">
							<option v-for="page in perPages" :value="page.value">{{ page.label }}</option>
						</select>
					</div>
				</div>
			</div>

			<pagination
				ref="pagination"
				:css="datatable.css.pagination"
				@vuetable-pagination:change-page="onChangePage"
				class="pull-right">
			</pagination>
		</div>

		<actions @destroy="destroy" @duplicate="duplicate" ref="actions"></actions>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
	import VueElementLoading from 'vue-element-loading'
	import Actions from '@/components/management/budgets/views/Actions'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,
			'loading': VueElementLoading,
			'actions': Actions,
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/budgets/datatable',
					loading: true,
					moreParams: {
						filter: {
							allowDate: false,
							date: null,
							text: null,
							assigned_to: this.user.id,
							budget_status_id: null,
						}
					},
					page: 100,
					path: '',
					sortOrder: null,
					css: {
						table: {
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [],
				},

				fields_default: [
					{
						name: '__slot:id',
						title: this.$platform.setting.number_symbol,
						sortField: 'id',
					},
					{
						name: '__slot:read',
						title: 'Visto',
					},
					{
						name: '__slot:title',
						title: 'Título',
						sortField: 'title',
					},
					{
						name: '__slot:customer',
						title: 'Cliente',
					},
					{
						name: '__slot:status',
						title: 'Estado',
						sortField: 'budget_status_id',
						visible: false,
					},
					{
						name: '__slot:base_amount',
						title: 'Precio',
						sortField: 'base_amount',
						visible: false,
					},
					{
						name: 'discount',
						title: 'Dto.',
						sortField: 'discount',
						visible: false,
					},
					{
						name: '__slot:save',
						title: 'Ahorro',
						sortField: 'save',
						visible: false,
					},
					{
						name: '__slot:amount',
						title: 'Base imponible',
						sortField: 'amount',
					},
					{
						name: '__slot:taxes',
						title: 'Impuestos',
						sortField: 'taxes',
					},
					{
						name: '__slot:total',
						title: 'Total',
						sortField: 'total',
					},
					{
						name: '__slot:assigned',
						title: 'Agente',
						visible: false,
					},
					{
						name: '__slot:author',
						title: 'Autor',
						visible: false,
					},
					{
						name: 'created_at',
						title: 'Fecha',
						callback: function(value) {
							return moment(value).format('DD/MM/YY')
						},
						sortField: 'created_at',
					},
					{
						name: '__slot:actions',
						title: '',
					}
				],

				fields_sent: [
					{
						name: '__slot:id',
						title: this.$platform.setting.number_symbol,
						sortField: 'id',
					},
					{
						name: '__slot:read',
						title: 'Visto',
					},
					{
						name: '__slot:title',
						title: 'Título',
						sortField: 'title',
					},
					{
						name: '__slot:customer',
						title: 'Cliente',
					},
					{
						name: '__slot:status',
						title: 'Estado',
						sortField: 'budget_status_id',
						visible: false,
					},
					{
						name: '__slot:base_amount',
						title: 'Precio',
						sortField: 'base_amount',
						visible: false,
					},
					{
						name: 'discount',
						title: 'Dto.',
						sortField: 'discount',
						visible: false,
					},
					{
						name: '__slot:save',
						title: 'Ahorro',
						sortField: 'save',
						visible: false,
					},
					{
						name: '__slot:amount',
						title: 'Base imponible',
						sortField: 'amount',
					},
					{
						name: '__slot:taxes',
						title: 'Impuestos',
						sortField: 'taxes',
					},
					{
						name: '__slot:total',
						title: 'Total',
						sortField: 'total',
					},
					{
						name: '__slot:assigned',
						title: 'Agente',
						visible: false,
					},
					{
						name: '__slot:author',
						title: 'Autor',
						visible: false,
					},
					{
						name: 'created_at',
						title: 'Fecha',
						callback: function(value) {
							return moment(value).format('DD/MM/YY')
						},
						sortField: 'created_at',
					},
					{
						name: '__slot:sent_at',
						title: 'Enviado',
						sortField: 'sent_at',
					},
					{
						name: '__slot:actions',
						title: '',
					}
				],

				statuses: null,
				status: null,

				sortOrder: [
					{
						field: 'created_at',
						sortField: 'created_at',
						direction: 'desc',
					}
				],
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getStatuses()
			},
			getStatuses() {
				this.$http.get('admin/management/budgets/statuses')
				.then(response => {
					this.statuses = response.body
					this.loadSentStatus()
				})
			},
			loadSentStatus() {
				if(this.statuses) {
					if(this.statuses.length) {
						var status = this.statuses.find(function(element) {
							return element.id == 2
						})
						if(status) {
							this.changeFields(status)
							this.loadStatus(status)
						}
					}
				}
			},
			loadStatus(status) {
				this.changeFields(status)
				this.status = status
				this.datatable.moreParams.filter.budget_status_id = status.id
				this.$nextTick( () => this.$refs.datatable.normalizeFields())
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			changeFields(status) {
				this.datatable.fields = []
				if(status.id == 2) {
					this.datatable.fields = this.fields_sent
					this.datatable.sortOrder = [
						{
							field: 'sent_at',
							sortField: 'sent_at',
							direction: 'desc',
						}
					]
				} else {
					this.datatable.sortOrder = this.sortOrder
					this.datatable.fields = this.fields_default
				}
			},
			//--
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
				this.loadDropdowns()
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			//--
			loadDropdowns() {
				$('.table-responsive').on('show.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "inherit" )
				});

				$('.table-responsive').on('hide.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "auto" )
				})
			},
			editOrContinue(response) {
				var that = this
				swal({
					title: response.body.title,
					text: response.body.text,
					type: response.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Editar',
					cancelButtonText: 'Continuar',
				}).then(function () {
					that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/budgets/' + response.body.data.id + '/edit')
				}).catch()
			},
			changeStatus(data) {
				var select = document.querySelector('#select-statuses-budget-' + data.id)
				select.setAttribute('disabled', true)
				this.$http.get('admin/management/budgets/' + data.id + '/change/status/' + data.budget_status_id)
					.then(response => {
						select.removeAttribute('disabled')
						this.reload()
					}).catch(response => {
						select.removeAttribute('disabled')
						if(response.status == 409) {
							swal({
								title: response.statusText,
								text: response.body,
								type: 'warning',
							})
						}
						this.reload()
					})
			},
			duplicate(data) {
				var that = this
				swal.queue([{
						title: this.$t("messages.attention"),
						text: "Se duplicará el presupuesto",
						type: "warning",
						showCancelButton: true,
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showLoaderOnConfirm: true,
						preConfirm: function () {
							return new Promise(function (resolve) {
								that.$http.get('admin/management/budgets/' + data.id + '/duplicate')
								.then(response => {
									that.reload()
									that.editOrContinue(response)
								}).catch(function(response) {
									that.loading = false
									console.log(response)
								})
							})
						}
					}]).catch(swal.noop)
			},
			destroy: function(budget) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/budgets/' + budget.id)
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/activity/views/Budgets.vue